import { useTheme } from '@mui/material'
import { keyframes, styled } from '@mui/material/styles'

const grow = (props) => keyframes`
	0%,
	100% {
		transform: scale(0);
		width: ${props.height};
		left: ${props.posX};
	}
	3% {
		width: ${props.height};
		transform: scale(1);
	}
	6% {
		width: ${props.width};
		left: ${props.posX};
	}
	23% {
		left: ${props.endAnimationPoint};
		width: ${props.height};
		transform: scale(1);
	}
	25% {
		transform: scale(0);
		left: ${props.endAnimationPoint};
		width: ${props.height};
	}
`

type BubblePropsStyled = {
	posX: string
	posY: string
	width: string
	height: string
	borderRadius: string
	color: string
	delay: string
	endAnimationPoint: string
}

const Bubble = styled('div')<BubblePropsStyled>`
	position: absolute;
	top: ${(props) => props.posY};
	left: ${(props) => props.posX};
	width: 0;
	height: ${(props) => props.height};
	border-radius: ${(props) => props.borderRadius};
	background-color: ${(props) => props.color};
	display: inline-block;
	animation: ${(props) => grow(props)} 3000ms linear infinite;
	animation-delay: ${(props) => props.delay};
`

/**
 * Display a loader with the BEP bubbles background
 */
export default function LoaderBubbles() {
	const theme = useTheme()
	return (
		<div
			style={{
				position: 'absolute',
				width: '100vw',
				height: '100vh',
				opacity: 0.8,
				overflow: 'hidden',
			}}
		>
			<SingleBubble
				posX={800}
				posY={10}
				color={theme.palette.info.main}
				width={100}
				height={4}
				delay="1s"
			/>
			<SingleBubble
				posX={400}
				posY={15}
				color={theme.palette.warning.main}
				width={200}
				height={6}
				delay="2s"
			/>
			<SingleBubble
				posX={200}
				posY={35}
				color={theme.palette.warning.main}
				width={200}
				height={2}
				delay="3.5s"
			/>
			<SingleBubble
				posX={520}
				posY={95}
				color={theme.palette.success.main}
				width={300}
				height={6}
				delay="6.2s"
			/>
			<SingleBubble
				posX={100}
				posY={175}
				color={theme.palette.info.main}
				width={80}
				height={12}
				delay="0s"
			/>
			<SingleBubble
				posX={1300}
				posY={180}
				color={theme.palette.info.light}
				width={180}
				height={3}
				delay="4.3s"
			/>
			<SingleBubble
				posX={840}
				posY={210}
				color={theme.palette.warning.dark}
				width={230}
				height={12}
				delay="0.65s"
			/>
			<SingleBubble
				posX={800}
				posY={250}
				color={theme.palette.info.dark}
				width={130}
				height={6}
				delay="0.85s"
			/>
			<SingleBubble
				posX={10}
				posY={280}
				color={theme.palette.primary.main}
				width={230}
				height={10}
				delay="0.15s"
			/>
			<SingleBubble
				posX={600}
				posY={380}
				color={theme.palette.secondary.main}
				width={80}
				height={6}
				delay="3.15s"
			/>
			<SingleBubble
				posX={900}
				posY={450}
				color={theme.palette.warning.dark}
				width={280}
				height={2}
				delay="2.15s"
			/>
			<SingleBubble
				posX={230}
				posY={520}
				color={theme.palette.primary.main}
				width={345}
				height={10}
				delay="3.05s"
			/>
			<SingleBubble
				posX={30}
				posY={591}
				color={theme.palette.primary.main}
				width={140}
				height={3}
				delay="1.67s"
			/>
			<SingleBubble
				posX={930}
				posY={627}
				color={theme.palette.primary.main}
				width={340}
				height={2}
				delay="2.53s"
			/>
			<SingleBubble
				posX={702}
				posY={693}
				color={theme.palette.info.main}
				width={123}
				height={8}
				delay="3.81s"
			/>
			<SingleBubble
				posX={-10}
				posY={748}
				color={theme.palette.secondary.dark}
				width={321}
				height={2}
				delay="0.81s"
			/>
			<SingleBubble
				posX={1100}
				posY={803}
				color={theme.palette.primary.main}
				width={821}
				height={8}
				delay="0s"
			/>
		</div>
	)
}

type BubbleProps = {
	posX: number
	posY: number
	width: number
	height: number
	color: string
	delay: string
}

function SingleBubble({ posY, posX, color, width, height, delay }: BubbleProps) {
	return (
		<Bubble
			color={color}
			width={`${width}px`}
			height={`${height}px`}
			borderRadius={`${height / 2}px`}
			delay={delay}
			endAnimationPoint={`${posX + (width - height)}px`}
			posX={`${posX}px`}
			posY={`${posY}px`}
		/>
	)
}
